export const SPONSORED_PRODUCT_MIN_LENGTH = 2;
export const SPONSORED_PRODUCT_DESKTOP_MIN_LENGTH = 4;
